/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/resetPassword.scss';

import React, {KeyboardEventHandler, MouseEventHandler} from 'react';

import {ChangeFunction, Loader, preventDefault} from '@dvrd/dvr-controls';

import {useTranslation} from 'react-i18next';

import {ResetErrorHandler, ResetPasswordErrors} from '../../../../util/interfaces';

import PasswordStrength from '../../../password/passwordStrength';

import {BolmateButton, BolmatePasswordInput} from '../../../controls';

import Image from '../../../misc/image';

interface Props {
    onChange: (key: 'pass' | 'confirm') => ChangeFunction;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onResetError: ResetErrorHandler<ResetPasswordErrors>;
    password: string;
    confirmPassword: string;
    loading: boolean;
    errors: ResetPasswordErrors;
}

export default function ResetPassword(props: Props) {
    const {t} = useTranslation();
    const {loading, errors, confirmPassword, onChange, password, onResetError, onSubmit} = props;
    return (
        <div className='reset-password'>
            <div className='logo-header'>
                <Image name='logo' className='logo' />
            </div>
            <div style={{position: 'relative'}}>
                <Loader active={loading} />
                <div className='header-container'>
                    <h1 className='header-title'>{t('auth.resetPassword.title', 'Wachtwoord opnieuw instellen')}</h1>
                    <label className='sub-title'>{t('auth.resetPassword.subtitle', 'Kies een nieuw wachtwoord')}</label>
                </div>
                <form onSubmit={preventDefault} className='form'>
                    <BolmatePasswordInput
                        value={password}
                        onChange={onChange('pass')}
                        label={t('auth.resetPassword.newPasswordLabel', 'Nieuw wachtwoord')}
                        error={errors.password}
                        onFocus={onResetError('password')}
                        inputProps={{
                            autoComplete: 'new-password',
                            placeholder: t('auth.resetPassword.newPasswordPlaceholder', 'Nieuw wachtwoord')
                        }}
                    />
                    <PasswordStrength value={password} />
                    <BolmatePasswordInput
                        value={confirmPassword}
                        onChange={onChange('confirm')}
                        label={t('auth.resetPassword.confirmPasswordLabel', 'Herhaal wachtwoord')}
                        error={errors.confirmPassword}
                        onFocus={onResetError('confirmPassword')}
                        inputProps={{
                            autoComplete: 'new-password',
                            placeholder: t('auth.resetPassword.confirmPasswordPlaceholder', 'Herhaal wachtwoord')
                        }}
                    />
                </form>
                <div className='btn-container'>
                    <BolmateButton
                        onClick={onSubmit}
                        label={t('auth.resetPassword.save', 'Opslaan')}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    );
}
